export const services = {
  devxfactor: {
    seo: {
      title: 'DevX Factor | FactorStreet',
      description:
        'DevX Factor is a FactorStreet SaaS product for software requirements, proposals, invoices, and AI-powered software blueprints.',
    },
    hero: {
      label: 'SAAS / SOFTWARE PLANNING',
      title: 'DevX Factor',
      headline: 'Turning project ideas into execution-ready software plans.',
      description:
        'DevX Factor helps founders, developers, students, and agencies convert raw project ideas into structured requirements, proposal-ready PDFs, invoices, and AI-powered software blueprints.',
      previewImage: '/services/devxfactor_500x300.png',
      websiteDisplay: 'WWW.DEVXFACTOR.COM',
      websiteUrl: 'https://devxfactor.com/',
      primaryCta: {
        label: 'Visit DevX Factor',
        href: 'https://devxfactor.com',
      },
      secondaryCta: {
        label: 'Explore FactorStreet Projects',
        to: '/',
      },
    },
    snapshot: [
      'SaaS product',
      'AI-assisted workflows',
      'Requirement forms',
      'Proposal PDFs',
      'Developer blueprints',
      'Agency-ready system',
    ],
    problem:
      'Software projects often fail because requirements are unclear, scope is scattered, and clients/developers do not share the same execution plan.',
    solution:
      'DevX Factor turns early project ideas into structured requirement documents, pricing-ready summaries, proposal PDFs, invoices, and development blueprints.',
    features: [
      'Structured requirement capture',
      'Custom form workflows',
      'Proposal-ready PDF generation',
      'AI software blueprints',
      'Invoice and documentation flows',
      'Admin-managed pricing/SEO/backups',
      'Agency/client workflow support',
      'Developer-ready planning outputs',
    ],
    audience: [
      'Web agencies',
      'Freelance developers',
      'Startup founders',
      'Students building projects',
      'Product teams',
      'Business owners planning applications',
    ],
    investorValue: [
      'SaaS business potential',
      'Productized project planning workflow',
      'Reusable across agencies and freelancers',
      'AI-driven documentation advantage',
      'Potential recurring revenue model',
      'Strong fit with SatyamCode development ecosystem',
    ],
    factorStreetFit:
      'DevX Factor is the software planning product layer inside FactorStreet, converting project discovery into structured outputs that can support development services, agency workflows, and future SaaS revenue.',
    roadmap: [
      'Agency subscription model',
      'AI proposal/blueprint upgrades',
      'More project templates',
      'Team collaboration workflows',
      'Marketplace/integrations',
      'Developer productivity tools',
    ],
    cta: {
      title: 'Explore the software planning layer of FactorStreet.',
      description:
        'DevX Factor shows how FactorStreet can turn messy project discovery into repeatable SaaS workflows for agencies, founders, and developers.',
      primaryCta: {
        label: 'Visit DevX Factor',
        href: 'https://devxfactor.com',
      },
      secondaryCta: {
        label: 'Contact FactorStreet',
        to: '/contact',
      },
    },
  },
  satyamcode: {
    seo: {
      title: 'SatyamCode | FactorStreet',
      description:
        'SatyamCode is FactorStreet\'s full-stack MERN development and resource ecosystem for production-ready web systems.',
    },
    hero: {
      label: 'FULL-STACK DEVELOPMENT / RESOURCES',
      title: 'SatyamCode',
      headline: 'A full-stack development and learning ecosystem.',
      description:
        'SatyamCode is the personal development brand and resource platform of Satyam Kumar, focused on MERN development, client projects, technical resources, and production-ready web systems.',
      previewImage: '/services/satyamcode_500x300.png',
      websiteDisplay: 'WWW.SATYAMCODE.COM',
      websiteUrl: 'https://satyamcode.com/',
      primaryCta: {
        label: 'Visit SatyamCode',
        href: 'https://satyamcode.com',
      },
      secondaryCta: {
        label: 'Contact for Development',
        to: '/contact',
      },
    },
    snapshot: [
      'Full-stack MERN development',
      'Live deployed systems',
      'Technical resource library',
      'Client lead-generation funnel',
      'Project CMS',
      'Resources CMS',
    ],
    problem:
      'Many businesses need practical web applications, dashboards, CMS systems, and reliable developer ownership, but struggle to find end-to-end technical execution.',
    solution:
      'SatyamCode positions FactorStreet\'s software-building capability through live systems, resources, project examples, and structured client intake workflows.',
    features: [
      'Full-stack MERN project development',
      'Business websites and dashboards',
      'CMS/resource systems',
      'Admin panels and workflows',
      'API/backend systems',
      'Contact and lead-generation flows',
      'SEO-ready dynamic pages',
      'Developer education resources',
    ],
    audience: [
      'Small businesses',
      'Founders',
      'Agencies',
      'Students/developers',
      'Education platforms',
      'Product builders',
    ],
    investorValue: [
      'Builds trust for service revenue',
      'Supports DevX Factor adoption',
      'Demonstrates in-house technical capability',
      'Generates client development opportunities',
      'Creates long-term content/resource traffic',
      'Strengthens founder-led execution credibility',
    ],
    factorStreetFit:
      'SatyamCode is the execution and credibility layer of FactorStreet, proving that the portfolio can design, build, deploy, and maintain real web systems.',
    roadmap: [
      'More developer resources',
      'Project libraries',
      'Client case studies',
      'Service lead funnel',
      'AI-assisted development workflows',
      'Paid learning/resources later if needed',
    ],
    cta: {
      title: 'See FactorStreet\'s software execution capability in action.',
      description:
        'SatyamCode connects portfolio credibility, client development, and technical education into one practical full-stack ecosystem.',
      primaryCta: {
        label: 'Visit SatyamCode',
        href: 'https://satyamcode.com',
      },
      secondaryCta: {
        label: 'Start a Development Conversation',
        to: '/contact',
      },
    },
  },
  physicsfactor: {
    seo: {
      title: 'PhysicsFactor | FactorStreet',
      description:
        'PhysicsFactor is a FactorStreet education platform for structured physics theory, concept-building questions, and chapter-wise tests.',
    },
    hero: {
      label: 'EDUCATION PLATFORM',
      title: 'PhysicsFactor',
      headline: 'Making physics systematic, structured, and easier to master.',
      description:
        'PhysicsFactor is an education platform focused on concept clarity, concise revision, progressive practice, and chapter-wise testing for physics learners.',
      previewImage: '/services/physicsfactor_500x300.png',
      websiteDisplay: 'WWW.PHYSICSFACTOR.COM',
      websiteUrl: 'https://physicsfactor.com/',
      primaryCta: {
        label: 'Visit PhysicsFactor',
        href: 'https://physicsfactor.com',
      },
      secondaryCta: {
        label: 'Explore Education Brands',
        to: '/services/satyamsir',
      },
    },
    snapshot: [
      'Physics learning platform',
      'Concise theory',
      'Concept builder Q&A',
      'Chapter-wise tests',
      'Structured revision',
      'Student-focused learning workflows',
    ],
    problem:
      'Students often struggle with physics because concepts, formulas, practice, and tests are scattered across different resources without a systematic progression.',
    solution:
      'PhysicsFactor organizes learning into structured theory, concept-building questions, difficulty levels, and chapter tests so students can revise faster and build problem-solving confidence.',
    capabilitySections: [
      {
        title: 'Brief & Concise Theory',
        description:
          'Important formulas and theory points are organized in a brief and precise format for fast revision before practice or exams.',
      },
      {
        title: 'Concept Builder Q&A',
        description:
          'Subtopic-wise questions arranged across increasing difficulty levels help students develop concepts gradually.',
      },
      {
        title: 'Test Your Understanding',
        description:
          'Chapter-wise tests help students check confidence, identify weak areas, and track conceptual understanding.',
      },
    ],
    features: [
      'Substitute for scattered reference material',
      'In-depth researched content',
      'Chapter summary before practice',
      'Solutions provided for important questions',
      'Plenty of practice problems and tests',
      'Systematic problem-solving approach',
    ],
    audience: [
      'Class 11/12 students',
      'JEE aspirants',
      'NEET aspirants',
      'CBSE/ICSE students',
      'Foundation learners',
      'Students needing revision and practice',
    ],
    investorValue: [
      'Education platform with reusable content',
      'Can scale through digital content and tests',
      'Strong link with tutoring brand SatyamSir',
      'Long-term SEO/content potential',
      'Can expand into structured courses/resources',
      'Builds credibility in education vertical',
    ],
    factorStreetFit:
      'PhysicsFactor is the structured education platform inside FactorStreet, pairing reusable learning content with the student-facing mentorship credibility of SatyamSir.',
    roadmap: [
      'More chapters and subjects',
      'Better test workflows',
      'Student dashboards',
      'Performance tracking',
      'Paid resources/course packaging',
      'Integration with SatyamSir tutoring',
    ],
    cta: {
      title: 'Explore the education-platform side of FactorStreet.',
      description:
        'PhysicsFactor turns physics learning into organized content, practice, and testing workflows that can grow with the education portfolio.',
      primaryCta: {
        label: 'Visit PhysicsFactor',
        href: 'https://physicsfactor.com',
      },
      secondaryCta: {
        label: 'View SatyamSir',
        to: '/services/satyamsir',
      },
    },
  },
  satyamsir: {
    seo: {
      title: 'SatyamSir | FactorStreet',
      description:
        'SatyamSir is FactorStreet\'s founder-led physics tutoring and mentoring brand for personal student support.',
    },
    hero: {
      label: 'TUTORING BRAND',
      title: 'SatyamSir',
      headline: 'Personal physics mentoring and student-focused learning support.',
      description:
        'SatyamSir is the tutoring and education brand led by Satyam Kumar, focused on physics mentoring, student guidance, concept clarity, and exam-oriented preparation.',
      previewImage: '/services/satyamsir_500x300.png',
      websiteDisplay: 'WWW.SATYAMSIR.COM',
      websiteUrl: 'https://satyamsir.com/',
      primaryCta: {
        label: 'Visit SatyamSir',
        href: 'https://satyamsir.com',
      },
      secondaryCta: {
        label: 'Contact for Tutoring',
        to: '/contact',
      },
    },
    snapshot: [
      '10+ years physics coaching experience',
      'JEE / NEET / board support',
      'Personal mentoring',
      'Doubt solving',
      'Chapter-wise guidance',
      'Student learning workflows',
    ],
    problem:
      'Many students need more than recorded content. They need personal attention, doubt solving, structured practice, and guidance on how to approach physics problems.',
    solution:
      'SatyamSir focuses on one-to-one mentoring, concept clarity, problem-solving methods, practice sheets, tests, and personal academic guidance.',
    capabilitySections: [
      {
        title: 'Personal 1-1 Tutoring',
        description:
          'Focused personal sessions for students needing direct guidance, concept explanation, and exam preparation support.',
      },
      {
        title: 'Exam Coverage',
        items: [
          'IIT JEE Mains',
          'IIT JEE Advanced',
          'NEET UG',
          'Olympiad Exams',
          'CBSE Board',
          'ICSE Board',
          'IGCSE Board',
          'AP Physics',
          'SAT Physics',
          'High School Physics',
          'College Physics',
        ],
      },
      {
        title: 'Teaching Approach',
        items: [
          'Understanding in-depth concepts',
          'Exposure to different numerical varieties',
          'Developing problem-solving approach',
          'Developing thinking skills',
        ],
      },
      {
        title: 'Mentorship Support',
        items: [
          'Daily practice sheets',
          'Chapter-wise practice tests',
          'Regular doubt discussion',
          'Personal monitoring and guidance',
        ],
      },
    ],
    audience: [
      'JEE/NEET aspirants',
      'Class 9-12 students',
      'Board exam students',
      'Foundation students',
      'International curriculum learners',
      'Students needing personal mentoring',
    ],
    investorValue: [
      'Strong founder-led education credibility',
      'Connects directly with PhysicsFactor',
      'Converts trust into tutoring/service revenue',
      'Can support future digital course ecosystem',
      'Builds education brand authority',
      'Provides real student-facing feedback for product improvement',
    ],
    factorStreetFit:
      'SatyamSir is the human mentorship layer of FactorStreet\'s education vertical, providing trust, direct student understanding, and feedback that can improve PhysicsFactor over time.',
    roadmap: [
      'Structured mentorship programs',
      'Better booking/demo system',
      'Course/resource integration',
      'Student progress tracking',
      'PhysicsFactor content integration',
      'More teacher-led offerings later',
    ],
    cta: {
      title: 'Connect with the mentorship brand behind the education vertical.',
      description:
        'SatyamSir gives FactorStreet a direct student-facing education channel built on concept clarity, guidance, and personal academic support.',
      primaryCta: {
        label: 'Visit SatyamSir',
        href: 'https://satyamsir.com',
      },
      secondaryCta: {
        label: 'Contact for Tutoring',
        to: '/contact',
      },
    },
  },
};
